import { SCHEDULE_CODE_TYPES } from './constants';

export const isLoadCode = (codeType: string): boolean => {
  return codeType === SCHEDULE_CODE_TYPES.LOAD_CODE;
};

export const isPickupCode = (codeType: string): boolean => {
  return codeType === SCHEDULE_CODE_TYPES.CLIENT_CODE;
};

export const isReclaimCode = (codeType: string): boolean => {
  return codeType === SCHEDULE_CODE_TYPES.RECLAIM_CODE;
};
